export enum IsSuccess {
    True = 'True',
    False = 'False'
  }